import axios from 'axios'

const module = {
    namespaced: true,
    state: {
        post: [],
        postPayments: []
    },
    mutations: {
        setConsult: (state, info) => state.post = info,
        setPayment: (state, info) => state.postPayments = info,
        addPayment: (state, info) => {
            info.postPayments.editableFlag = true
            state.postPayments.push(info.postPayments)
        },
    },
    actions: {
        async fetchConsul({commit}) {
            const response = await axios.get('personal-consultation')
            commit('setConsult', response.data.personal_consultation.reverse())
        },
        async fetchPayments({commit}, data) {
            const response = await axios.get(`personal-consultation/${data.id}/payments`)
            commit('setPayment', response.data.consultation_payments)
        },
        async addUserPayment ({commit}, data) {
            const response = await axios.post(`personal-consultation/${data.id}/pay/transfer`, data.dataPost)
            commit ('addPayment', response.data)
        },
    }
}

export default module